export const TOGGLE_MENU = 'TOGGLE_MENU'
export const TOGGLE_COMMON_MENU = 'TOGGLE_COMMON_MENU'
export const SET_SCROLL_LOCK = 'SET_SCROLL_LOCK'

/** Default state for UI module */
export const defaultState = {
  menuOpen: false,
  commonMenuOpen: false,
  scrollLocked: false
}

/** UI State mutations */
export const mutations = {
  [TOGGLE_MENU] (state, isOpen) {
    state.menuOpen = isOpen
  },
  [TOGGLE_COMMON_MENU] (state, isOpen) {
    state.commonMenuOpen = isOpen
  },
  [SET_SCROLL_LOCK] (state, isLocked) {
    state.scrollLocked = isLocked
  }
}

/**
 * UI State Vuex module
 */
export default {
  namespaced: true,
  state: { ...defaultState },
  mutations
}
